import React from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../config/authConfig';
import { LogIn } from 'lucide-react';

export const LoginPage: React.FC = () => {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginPopup(loginRequest).catch((error) => {
      console.error('Login failed:', error);
    });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-san-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <div className="mx-auto h-12 w-12 flex items-center justify-center rounded-full bg-san-green">
            <LogIn className="h-6 w-6 text-white" />
          </div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-san-gray-900">
            Sign in to SAN Tokens
          </h2>
          <p className="mt-2 text-center text-sm text-san-gray-600">
            Access the Sustainable Agriculture Network token management system
          </p>
        </div>
        
        <div className="mt-8 space-y-6">
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <div className="space-y-6">
              <div className="text-center">
                <h3 className="text-lg font-medium text-san-gray-900 mb-4">
                  Microsoft Azure AD Authentication
                </h3>
                <p className="text-sm text-san-gray-500 mb-6">
                  Use your organization credentials to access the system
                </p>
                
                <button
                  onClick={handleLogin}
                  className="w-full flex justify-center items-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-san-blue hover:bg-san-blue-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-san-blue transition-colors duration-200"
                >
                  <LogIn className="w-4 h-4 mr-2" />
                  Sign in with Microsoft
                </button>
              </div>
              
              <div className="mt-6">
                <div className="relative">
                  <div className="absolute inset-0 flex items-center">
                    <div className="w-full border-t border-san-gray-300" />
                  </div>
                  <div className="relative flex justify-center text-sm">
                    <span className="px-2 bg-white text-san-gray-500">Features</span>
                  </div>
                </div>
                
                <div className="mt-6 grid grid-cols-1 gap-3">
                  <div className="flex items-center">
                    <div className="flex-shrink-0">
                      <div className="h-2 w-2 rounded-full bg-san-green"></div>
                    </div>
                    <div className="ml-3 text-sm text-san-gray-600">
                      Track member token achievements
                    </div>
                  </div>
                  <div className="flex items-center">
                    <div className="flex-shrink-0">
                      <div className="h-2 w-2 rounded-full bg-san-green"></div>
                    </div>
                    <div className="ml-3 text-sm text-san-gray-600">
                      Manage activities and contributions
                    </div>
                  </div>
                  <div className="flex items-center">
                    <div className="flex-shrink-0">
                      <div className="h-2 w-2 rounded-full bg-san-green"></div>
                    </div>
                    <div className="ml-3 text-sm text-san-gray-600">
                      Monitor membership fee compliance
                    </div>
                  </div>
                  <div className="flex items-center">
                    <div className="flex-shrink-0">
                      <div className="h-2 w-2 rounded-full bg-san-green"></div>
                    </div>
                    <div className="ml-3 text-sm text-san-gray-600">
                      Generate reports and analytics
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="text-center text-xs text-san-gray-500">
            <p>
              By signing in, you agree to the SAN terms of service and privacy policy.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};